module.exports = new __parcel__URL__("dark-mode.c2768bcf.svg").toString();